<template>
  <DSDropdownMenu v-model:open="isOpen">
    <DSDropdownMenuTrigger as-child>
      <DSButton
        size="icon-sm"
        variant="ghost"
        :class="triggerClass"
        :disabled
        @click.stop
      >
        <component
          :is="isOpen ? openIcon : EllipsisVerticalIcon"
          class="size-3.5 shrink-0"
          aria-hidden="true"
        />
      </DSButton>
    </DSDropdownMenuTrigger>
    <DSDropdownMenuContent
      :side
      :align
    >
      <DSDropdownMenuItem @select="emit('rename')">
        <PencilIcon
          class="size-3.5 shrink-0"
          aria-hidden="true"
        />
        Rename
      </DSDropdownMenuItem>
      <DSDropdownMenuItem @select="handleConfigure">
        <Settings2Icon
          class="size-3.5 shrink-0"
          aria-hidden="true"
        />
        Configure
      </DSDropdownMenuItem>
      <DSDropdownMenuItem @select="handleDuplicate">
        <CopyIcon
          class="size-3.5 shrink-0"
          aria-hidden="true"
        />
        Duplicate
      </DSDropdownMenuItem>
      <DSDropdownMenuItem
        class="text-destructive focus:bg-destructive-subtle focus:text-destructive"
        @select="handleRemove"
      >
        <TrashIcon
          class="size-3.5 shrink-0"
          aria-hidden="true"
        />
        Remove
      </DSDropdownMenuItem>
    </DSDropdownMenuContent>
  </DSDropdownMenu>
</template>

<script setup lang="ts">
import type { Component } from 'vue'
import { ref } from 'vue'

import { NavigationItem } from '@types'

import { DSButton, DSDropdownMenu, DSDropdownMenuContent, DSDropdownMenuItem, DSDropdownMenuTrigger } from '@ds'

import { ChevronRightIcon, CopyIcon, EllipsisVerticalIcon, PencilIcon, Settings2Icon, TrashIcon } from '@lucide/vue'

import { useFlyoutHoldOpen } from '@/components/DS/patterns/Sidebar/useFlyoutHoldOpen'

import { useDashboard } from '../utils/useDashboard'

type Props = {
  child: NavigationItem
  disabled?: boolean
  side?: 'top' | 'right' | 'bottom' | 'left'
  align?: 'start' | 'center' | 'end'
  triggerClass?: string
  openIcon?: Component
}

const { child, side = 'right', align = 'start', triggerClass, openIcon = ChevronRightIcon } = defineProps<Props>()

const emit = defineEmits<{
  rename: []
  click: []
}>()

const { configureDashboard, duplicateDashboard, removeDashboard } = useDashboard(child.routeParams?.slug)

const isOpen = ref(false)
useFlyoutHoldOpen(isOpen)

const handleConfigure = () => {
  emit('click')
  configureDashboard()
}

const handleDuplicate = () => {
  emit('click')
  duplicateDashboard()
}

const handleRemove = () => {
  removeDashboard()
}
</script>
